import React from 'react';

const PlaceDetails = ({ place, selected }) => {

    return (
        <>
            <div className="distributor-category">Breathing Air</div>
            <h4 dangerouslySetInnerHTML={{ __html: place.field_short_name }}></h4>
            <div className="distributor-places-phone-box">
                <div className="phone-box-icon"></div>
                <div className="phone-box-info"><a href={`tel:${place.field_phone}`}>{place.field_phone}</a></div>
            </div>
            <div className="distributor-places-contact-box">
                <div className="contact-box-icon"></div>
                <div className="contact-info-box">
                    <div className="contact-info-box-person">{place.field_main_point_of_contact}</div>
                    <div className="contact-info-box-email"><a href={`mailto:${place.field_email}`}>{place.field_email}</a></div>
                </div>
            </div>
            <div className="distributor-places-address-box">
                <div className="address-box-icon"></div>
                <div className="address-info-box">
                    <div className="address-info-box-text">{place.field_distributor_location}</div>
                    <div className="address-info-box-link">
                        <a href={`https://maps.google.com/?saddr=Current+Location&daddr=${place.field_distributor_location}`} target="_blank">{`${Drupal.t('Get Directions')}`}</a>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PlaceDetails;